var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq33(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22188,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4582,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0457,
    y1: 12.1824,
    x2: 50.282,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.37185,
    y1: 49.8543,
    x2: 12.6082,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.8078,
    y1: 38.6199,
    x2: 50.0441,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.13401,
    y1: 0.944118,
    x2: 12.3703,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.868 22.524C17.9333 21.6747 18.26 21.0073 18.848 20.522C19.4453 20.0273 20.2153 19.78 21.158 19.78C21.7833 19.78 22.32 19.892 22.768 20.116C23.216 20.34 23.552 20.648 23.776 21.04C24.0093 21.4227 24.126 21.8567 24.126 22.342C24.126 22.93 23.9533 23.4387 23.608 23.868C23.2627 24.2973 22.7727 24.5633 22.138 24.666V24.736C22.8007 24.8667 23.328 25.156 23.72 25.604C24.112 26.0427 24.308 26.6213 24.308 27.34C24.308 28.1427 24.0373 28.8007 23.496 29.314C22.964 29.818 22.1893 30.07 21.172 30.07C20.2013 30.07 19.4033 29.818 18.778 29.314C18.1527 28.8007 17.7933 28.0773 17.7 27.144H18.652C18.736 27.7693 18.9973 28.278 19.436 28.67C19.8747 29.0527 20.4533 29.244 21.172 29.244C21.8813 29.244 22.4227 29.0573 22.796 28.684C23.1787 28.3107 23.37 27.8347 23.37 27.256C23.37 25.8373 22.348 25.128 20.304 25.128H19.996V24.302H20.318C22.222 24.302 23.174 23.6813 23.174 22.44C23.174 21.8987 22.9967 21.4647 22.642 21.138C22.2873 20.802 21.7833 20.634 21.13 20.634C20.4953 20.634 19.968 20.802 19.548 21.138C19.1373 21.4647 18.8947 21.9267 18.82 22.524H17.868ZM26.0575 22.524C26.1228 21.6747 26.4495 21.0073 27.0375 20.522C27.6348 20.0273 28.4048 19.78 29.3475 19.78C29.9728 19.78 30.5095 19.892 30.9575 20.116C31.4055 20.34 31.7415 20.648 31.9655 21.04C32.1988 21.4227 32.3155 21.8567 32.3155 22.342C32.3155 22.93 32.1428 23.4387 31.7975 23.868C31.4521 24.2973 30.9621 24.5633 30.3275 24.666V24.736C30.9901 24.8667 31.5175 25.156 31.9095 25.604C32.3015 26.0427 32.4975 26.6213 32.4975 27.34C32.4975 28.1427 32.2268 28.8007 31.6855 29.314C31.1535 29.818 30.3788 30.07 29.3615 30.07C28.3908 30.07 27.5928 29.818 26.9675 29.314C26.3421 28.8007 25.9828 28.0773 25.8895 27.144H26.8415C26.9255 27.7693 27.1868 28.278 27.6255 28.67C28.0641 29.0527 28.6428 29.244 29.3615 29.244C30.0708 29.244 30.6121 29.0573 30.9855 28.684C31.3681 28.3107 31.5595 27.8347 31.5595 27.256C31.5595 25.8373 30.5375 25.128 28.4935 25.128H28.1855V24.302H28.5075C30.4115 24.302 31.3635 23.6813 31.3635 22.44C31.3635 21.8987 31.1861 21.4647 30.8315 21.138C30.4768 20.802 29.9728 20.634 29.3195 20.634C28.6848 20.634 28.1575 20.802 27.7375 21.138C27.3268 21.4647 27.0841 21.9267 27.0095 22.524H26.0575Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq33);
export default __webpack_public_path__ + "static/media/fq33.637012dd1a50df5b544eb32d2a0faed9.svg";
export { ForwardRef as ReactComponent };